export type PackagingFieldType = "number" | "text" | "select";

export const PACKAGING_FIELDS = {
  PIECES: "pieces",
  HU: "hu",
  WEIGHT: "weight",
  PACKAGE_TYPE: "packageType",
  LOOSE_PIECES: "loosePieces",
} as const;

export interface IFieldConfig {
  field: string;
  label: string;
  shortLabel: string;
  visible: boolean;
  required?: boolean;
  maxLength?: number;
  maxValue?: number;
  minValue?: number;
  /** Visual layout only — groups fields that render together and repeat on Add item. Does NOT affect packageDetails[] payload. */
  group?: string;
  /** Per-row payload flag. Only explicit `true` puts this field in each packageDetails[] row; `group` alone never implies per-row. */
  mapsToPackageDetails?: boolean;
  /** Input widget: text, number, or select. */
  type: PackagingFieldType;
  /** Model key when it differs from `field` (e.g. packageType → packageCode in packagingItems). */
  dataKey?: string;
  /** Span full row in the packaging grid to break 40/60 pairing. */
  fullWidth?: boolean;
}

export interface IMiscellaneousConfig {
  addItem: {
    visible: boolean;
    /** Which `group` to duplicate when Add item is clicked. */
    groupTarget?: string;
  };
  total: {
    label: string;
    visible: boolean;
    sourceFields?: string[];
  };
}

export interface IRawPackagingConfig {
  fields: IFieldConfig[];
  miscellaneous: IMiscellaneousConfig;
}

export interface IPackagingFieldsConfig {
  fieldOrder: string[];
  fieldMap: Record<string, IFieldConfig>;
  miscellaneous: IMiscellaneousConfig;
}

/** Returns true only when `mapsToPackageDetails: true` is explicit — `group` has no effect. */
export const resolveMapsToPackageDetails = (fieldCfg: IFieldConfig): boolean =>
  fieldCfg.mapsToPackageDetails === true;

/** True only when `mapsToPackageDetails: true` — `group` has no effect on row/shipment distinction. */
export const isPackageDetailsRowField = (fieldCfg: IFieldConfig): boolean =>
  fieldCfg.mapsToPackageDetails === true;
